"use client";

import { c as _c } from "react-compiler-runtime";
import { Camera } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Text } from "@/components/primitives";
import { useTranslation } from "@/core/i18n";
type WebsiteEmbedCameraStartOverlayProps = {
  onStart: () => void;
};
export function WebsiteEmbedCameraStartOverlay(t0) {
  const $ = _c(18);
  const {
    onStart
  } = t0;
  const {
    t
  } = useTranslation();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Camera aria-hidden={true} className="h-10 w-10 text-white/80" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t) {
    t2 = t("assessmentSteps.studioSession.embedCameraStart.title");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <Text component="p" text={t2} tone="white" variant="heading-sm" weight="medium" />;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("assessmentSteps.studioSession.embedCameraStart.body");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <Text component="p" text={t4} tone="white" variant="body-md" />;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t("assessmentSteps.studioSession.embedCameraStart.button");
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== onStart || $[12] !== t6) {
    t7 = <Button className="mt-2" onClick={onStart} type="button" variant="default">{t6}</Button>;
    $[11] = onStart;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t3 || $[15] !== t5 || $[16] !== t7) {
    t8 = <div className="absolute inset-0 z-50 flex items-center justify-center bg-black/90 px-6"><div className="flex max-w-sm flex-col items-center gap-4 text-center">{t1}{t3}{t5}{t7}</div></div>;
    $[14] = t3;
    $[15] = t5;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
}